var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mobile-tabs-wrapper"},_vm._l((_vm.options),function(item,index){return _c('div',{key:index,staticClass:"mobile-tabs-item",class:{
			'mobile-tabs-item--active': _setup.getSyncKeyValue(item) === _setup.activeTabId
		},on:{"click":function($event){return _setup.changeTabs(item)}}},[_c('span',[_vm._v(_vm._s(item[_vm.labelKey]))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }